import { render } from "./NanoswarmShortcut.vue?vue&type=template&id=638db1c0"
import script from "./NanoswarmShortcut.vue?vue&type=script&lang=js"
export * from "./NanoswarmShortcut.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__